import { EnumOption } from "./enum-option"

export const MatterScope = {
    All: 0,
    My: 1,
    MyTeam: 2,
}

export const MatterScopeList: EnumOption[] = [
    { value: MatterScope.All, label: 'All' },
    { value: MatterScope.My, label: 'My' },
    { value: MatterScope.MyTeam, label: 'My Team' },
]
